import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseAPIService } from '../base.api.service';

@Injectable()
export class LuckLevelService extends BaseAPIService {

    private ROUTES = {
        list: '/luck-level/list',
    };

    constructor(protected http: HttpClient) {
        super(http);
    }

    list(): Promise<any> {
        return this.http.get(this.ROUTES.list).toPromise();
    }
}
